export const addMonths = (months) => {
	const date = new Date();
	return date.setMonth(date.getMonth() + months);
};
